import {Popup} from "./Popup"
import {Panel} from "./Panel";
import {Demopanel} from "./Demopanel";
import {Modal} from "./Modal";
import {Range} from "./Range";
import {FileLoader} from "./FileLoader";
import {IconSet} from "./IconSet";
import {DoubleSwitch} from "./DoubleSwitch";
import {Spreadsheet} from "./Spreadsheet";

const AColorPicker = require('a-color-picker');

declare global {
    interface Window {
        theme: {
            id: string;
            url: string;
            backend: string;
            app: string;
            colorScheme: string;
            settings: {
                [key: string]: any
            }
            blocks: {
                [key: string]: any
            }
        }
    }
}

document.addEventListener( 'DOMContentLoaded',  () => {
    const theme = window.theme;

    //Creating a pop-up window
    const popup = new Popup ({
        window: `.panel`,
        overlay: `.panel__overlay`
    });
    popup.addTriggers(`.open-settings, .panel__overlay`);

    //Dropdown menu
    const menu = new Modal({
        window: `.panel-dropdown__window`,
        container: `.panel`
    });
    menu.addTriggers(`.panel-dropdown__trigger`);

    //Sidebar for demo versions
    const colors = JSON.parse(theme.colorScheme);
    const demopanel = new Demopanel({colors});
    demopanel.addOptions(`.panel-demo__option--color`, `color`);
    demopanel.addOptions(`.panel-demo__option--shadow`, `shadow`);
    demopanel.setBlockNameSwitch(`#panel-demo-blockname`, `.actions__blockname`);

    //Sidebar with theme settings
    const saveURL = `${theme.backend + theme.app}/?module=design&action=themeSettings&theme=${theme.id}`;
    const panel = new Panel({
        popup,
        saveURL,
        elements: {
            form: `.panel-admin`,
            save: `#save-settings`,
            spinner: `.panel-admin__spinner`,
            tabs: `.panel-tab`,
            pages: `.panel-settings__page`,
            groupTabs: `.panel-navigation__group-name`,
            groups: `.panel-navigation__group`
        }
    });
    panel.addMerged(`.panel-settings__merged`);
    panel.addSortable(`.sortable`);
    panel.addAction(`.edit-block`, `edit`);
    panel.addAction(`.view-block-code`, `code`, `.panel-code`);
    panel.addAction(`.delete-block`, `disable`, `.actions__spinner`);
    panel.addAction(`.panel-code__button`, `copy`, `.panel-code__content`);

    //Range sliders
    const rs = document.querySelectorAll(`.title-size`);
    rs.forEach(element => {
        const range = new Range({
            storage: element.querySelector(`[type=hidden]`),
            element: element.querySelector(`[name=range]`),
            values: [`H6`, `H5`, `H4`, `H3`, `H2`, `H1`]
        });
        range.initRadioGroup({
            element: element.querySelector(`[role=radiogroup]`),
            values: [`tiny`, `small`, `medium`, `big`, `extra`]
        });
    });

    //Color pickers
    AColorPicker.from(`.panel-settings__picker`,
        {
            showRGB: false,
            showHEX: false
        })
        .on(`change`, (picker: any, color: string) => {
            const storage = picker.element.parentElement.previousElementSibling;
            storage.value = `hsl(${picker.hsl[0]}, ${picker.hsl[1]}%, ${picker.hsl[2]}%)`;
    });

    //File loaders
    const fl = document.querySelectorAll(`.panel-settings__file`);
    fl.forEach(element => {
        const fileloader = new FileLoader({
            input: element.querySelector(`.drop-zone__input`),
            dropzone: element.querySelector(`.drop-zone`),
            hint: element.querySelector(`.drop-zone__text`),
            bin: element.querySelector(`.panel-settings__file-remove`),
            storage: element.querySelector(`[type=hidden]`)
        })
    });

    // Icon set
    const ism = new Modal({
        window: `.panel-iconset`,
        container: `.panel`
    });
    ism.addTriggers(`.iconset__icon`);

    const ds = document.querySelectorAll(`.iconset__control`);
    ds.forEach(element => {
        const doubleSwitch = new DoubleSwitch({
            checkbox: element.querySelector(`[type=checkbox]`),
            storage: element.querySelector(`[type=hidden]`),
            tabs: [
                element.querySelector(`.iconset__wrapper`),
                element.parentElement.nextElementSibling as HTMLElement
            ]
        });
    });

    const iconset = new IconSet({
        icons: document.querySelectorAll(`.iconset__item`),
        thumbnails: document.querySelectorAll(`.iconset__control`)
    });

    // Spreadsheets
    const tables = document.querySelectorAll(`.spreadsheet`);

    tables.forEach((table) => {
        const spreadsheet = new Spreadsheet({
            table,
            storage: table.previousElementSibling as HTMLInputElement,
            cells: table.querySelectorAll(`td`)
        });
        spreadsheet.addControls(`rows`, table.querySelector(`[data-structure=rows]`), 1, 50);
        spreadsheet.addControls(`columns`, table.querySelector(`[data-structure=columns]`), 1, 5);
    });

});
